// the translations
// (tip move them in a JSON file and import them,
// or even better, manage them separated from your code: https://react.i18next.com/guides/multiple-translation-files)
const resources = {
  en: {
    translation: {
      loading: 'Loading',
      'auditLog.operationName.COMPLETED_COMPLIANCE': 'Compliance Completed',
      'auditLog.operationName.PERFORM_SINGLE_COMPLIANCE':
        'Perform Single Compliance',
      'auditLog.operationName.SIGN_COMPLIANCE': 'Sign Compliance',
      'auditLog.operationName.CREATE_COMPLIANCE_LEDGER_REVISION':
        'Create Compliance Ledger Revision',
      'auditLog.operationName.CANCEL_COMPLIANCE_LEDGER_REVISION':
        'Abort Compliance Ledger Revision',
      'auditLog.operationName.RESET_COMPLIANCE_LEDGER_REVISION':
        'Reset Compliance Ledger Revision',
      'auditLog.operationName.UPDATE_GENERAL_ROLE': 'Update General Role',
      'auditLog.operationName.UPDATE_ALL_AIRCRAFTS_ROLE':
        'Update All Aircrafts Role',
      'auditLog.operationName.UPDATE_AIRCRAFT_ROLE': 'Update Aircraft Role',
      'auditLog.operationName.UPDATE_GENERAL_PERMISSION_ROLES':
        'Update General Permission Roles',
      'auditLog.operationName.UPDATE_ALL_AIRCRAFT_PERMISSION_ROLES':
        'Update All Aircraft Permission Roles',
      'auditLog.operationName.UPDATE_AIRCRAFT_PERMISSION_ROLES':
        'Update Aircraft Permission Roles',

      'auditLog.actionType.CREATE': 'Create',
      'auditLog.actionType.UPDATE': 'Update',
      'auditLog.actionType.DELETE': 'Delete',
      'auditLog.entityType.UserTenantMembership': 'User Tenant Membership',
      'auditLog.entityType.AircraftUsageParameter': 'Aircraft Usage Parameter',
      'auditLog.entityType.AircraftUsageLog': 'Aircraft Usage Log',
      'auditLog.entityType.ComponentUsageLog': 'Component Usage Log',
      'auditLog.entityType.InternalWorkOrder': 'Internal Work Order',
      'auditLog.entityType.InternalWorkItem': 'Internal Work Item',
      'auditLog.entityType.ComplianceLedger': 'Compliance Ledger',
      'auditLog.entityType.ComplianceActivity': 'Compliance Activity',
      'auditLog.entityType.ComplianceSignature': 'Compliance Signature',
      'auditLog.entityType.AircraftComponent': 'Aircraft Component',
      'auditLog.entityType.PartsTransaction': 'Parts Transaction',
      'auditLog.entityType.MaintenanceItem': 'Maintenance Item',
      'auditLog.entityType.ReturnToServiceStatement':
        'Return to Service Statement',
      'auditLog.entityType.MaintenanceItemTag': 'Maintenance Item Tag',
      'auditLog.entityType.MaintenanceNextDue': 'Maintenance Next Due',
      'auditLog.entityType.AttachedFile': 'Attached File',
      'auditLog.entityType.MaintenanceLogbook': 'Maintenance Logbook',
      'auditLog.entityType.MaintenanceLogbookActivity':
        'Maintenance Logbook Activity',
      'auditLog.entityType.IntegrationRegistration': 'Integration Registration',
      'auditLog.entityType.IntegrationOperation': 'Integration Operation',
      'auditLog.entityType.IntegrationLogs': 'Integration Logs',
      'auditLog.entityType.FeTableConfiguration': 'Table Column Configuration',
      'notification.actionTitle.finalizeLogbook': 'Finalize Logbook',

      'complianceLedger.status.IN_PROGRESS': 'In Progress',
      'complianceLedger.status.IN_REVIEW': 'In Review',
      'complianceLedger.status.COMPLETED': 'Completed',
      'complianceLedger.status.SIGN': 'Sign',
      'complianceLedger.status.COMPLETED_LOGBOOK': 'Logbook Completed',
      'complianceLedger.status.REVISION_IN_PROGRESS': 'Revision',

      // TODO remove DRAFT status once we no longer support v1
      'workOrder.status.DRAFT': 'In Progress',
      'workOrder.status.IN_PROGRESS': 'In Progress',
      'workOrder.status.COMPLETED': 'Completed',
      'workOrder.status.SIGN': 'Sign',
      'workOrder.status.COMPLETED_LOGBOOK': 'Logbook Completed',
      'workOrder.status.IN_REVIEW': 'In Review',

      'purchaseOrder.status.DRAFT': 'Draft',
      'purchaseOrder.status.OPEN': 'In Progress',
      'purchaseOrder.status.COMPLETED': 'Completed',
      'purchaseOrder.status.CANCELLED': 'Cancelled',

      'purchaseOrder.paymentTerms.null': '',
      'purchaseOrder.paymentTerms.NET_30': 'Net 30',
      'purchaseOrder.paymentTerms.WIRE_TRANSFER': 'Wire Transfer',
      'purchaseOrder.paymentTerms.CREDIT_CARD': 'Credit Card',

      'auditLogNotes.label': 'Change Reason',
      'auditLogNotes.placeholder':
        'Describe why this change is being made (e.g., correcting data, process update).',

      'toolTip.signatureProcessing':
        'Move the slider to adjust for image processing to make your signature look better.',

      'purchaseOrderItem.type.PART': 'Part',
      'purchaseOrderItem.type.SERVICE': 'Service',

      'purchaseOrderItem.condition.NEW': 'New',
      'purchaseOrderItem.condition.OVERHAULED': 'Overhauled',
      'purchaseOrderItem.condition.REPAIRED': 'Repaired',
      'purchaseOrderItem.condition.SERVICEABLE': 'Serviceable',
      'purchaseOrderItem.condition.INSPECTED': 'Inspected',

      'product.type.ROTABLE': 'Rotable',
      'product.type.CONSUMABLE': 'Consumable',
      'product.type.TOOL': 'Tool',
      'product.type.ASSEMBLY': 'Assembly',
      'product.type.OTHER': 'Other',

      'itemLifecycleEventType.CUSTOM': 'Custom',
      'itemLifecycleEventType.RECEIVED_FROM_PO': 'Received from purchase order',
      'itemLifecycleEventType.RECEIVED_RENTAL': 'Received rental',
      'itemLifecycleEventType.INSTALLED': 'Installed',
      'itemLifecycleEventType.REMOVED': 'Removed',
      'itemLifecycleEventType.REPAIRED': 'Repaired',
      'itemLifecycleEventType.RETIRED': 'Retired',
      'itemLifecycleEventType.CALIBRATION': 'Calibration',
      'itemLifecycleEventType.MISCELLANEOUS': 'Miscellaneous',

      'vendors.type.CUSTOMER': 'Customer',
      'vendors.type.SUPPLIER': 'Supplier',
      'vendors.type.MANUFACTURER': 'Manufacturer',

      'errors.unknown': 'An unexpected error occurred',
      'errors.default': 'An error occurred',
      'errors.products.DUPLICATE_PART_NUMBER':
        'A product with this part number already exists',

      'roles.admin': 'Admin',
      'roles.all-access': 'All Access',
      'roles.manager': 'Manager',
      'roles.mechanic': 'Mechanic',
      'roles.read-only': 'Read Only',
      'roles.unauthorized': 'Unauthorized',

      'reference.aiResearched': 'Reference researched by AI',
      'reference.referenceType.MANUFACTURING_CODE': 'Manufacturing Code',

      'reference.entityType.MAINTENANCE_ITEM': 'Maintenance Item',
      'reference.entityType.AIRCRAFT_COMPONENT': 'Aircraft Component',
      'reference.entityType.AIRCRAFT': 'Aircraft',
      'reference.entityType.OTHER': 'Other',

      'reference.sourceStatus.ACTIVE': 'Active',
      'reference.sourceStatus.EXPIRED': 'Expired',
      'reference.sourceStatus.UNKNOWN': 'Unknown',

      'reference.mediaType.PDF': 'PDF',
      'reference.mediaType.DOCUMENT': 'Document',
      'reference.mediaType.IMAGE': 'Image',
      'reference.mediaType.OTHER': 'Other',
      'reference.mediaType.EXTERNAL_LINK': 'External Link',
      'reference.viewReference.MAINTENANCE_MANUAL': 'View Maintenance Manual',
      'reference.viewReference.ILLUSTRATED_PARTS_CATALOG': 'View Parts Catalog',
      'reference.viewReference.SERVICE_BULLETIN': 'View Service Bulletin',
      'reference.viewReference.AIRWORTHINESS_DIRECTIVE':
        'View Airworthiness Directive',
      'reference.viewReference.TECHNICAL_PUBLICATION':
        'View Technical Publication',
      'reference.viewReference.REGULATORY_DOCUMENT': 'View Regulatory Document',
      'reference.viewReference.TASK_CARD': 'View Task Card',
      'reference.viewReference.OTHER': 'View Reference',

      'referenceSource.publicationType.MAINTENANCE_MANUAL':
        'Maintenance Manual',
      'referenceSource.publicationType.ILLUSTRATED_PARTS_CATALOG':
        'Illustrated Parts Catalog',
      'referenceSource.publicationType.SERVICE_BULLETIN': 'Service Bulletin',
      'referenceSource.publicationType.AIRWORTHINESS_DIRECTIVE':
        'Airworthiness Directive',
      'referenceSource.publicationType.TECHNICAL_PUBLICATION':
        'Technical Publication',
      'referenceSource.publicationType.REGULATORY_DOCUMENT':
        'Regulatory Document',
      'referenceSource.publicationType.TASK_CARD': 'Task Card',
      'referenceSource.publicationType.OTHER': 'Other',

      'feedback.resolution.VALID': 'Valid',
      'feedback.resolution.INVALID': 'Invalid',
      'feedback.resolution.DUPLICATE': 'Duplicate',
      'feedback.resolution.NEEDS_CLARITY': 'Needs Clarity',
      'feedback.status.PENDING': 'Pending',

      'logbookIngestion.status.CREATED': 'Created',
      'logbookIngestion.status.PROCESSING': 'Processing',
      'logbookIngestion.status.PROCESSED': 'Processed',
      'logbookIngestion.status.LEDGER_GENERATED': 'Ledger Generated',
    },
  },
  fr: {
    translation: {
      'Welcome to React': 'Bienvenue à React et react-i18next',

      'errors.unknown': "Une erreur inattendue s'est produite",
      'errors.default': "Une erreur s'est produite",

      'errors.products.DUPLICATE_PART_NUMBER':
        'Un produit avec ce numéro de pièce existe déjà',

      'feedback.resolution.VALID': 'Valide',
      'feedback.resolution.INVALID': 'Invalide',
      'feedback.resolution.DUPLICATE': 'Dupliqué',
      'feedback.resolution.NEEDS_CLARITY': 'Nécessite des clarifications',
      'feedback.status.PENDING': 'En attente',
    },
  },
}
export default resources
